module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAJ1BMVEUAAAA7iMM7iMM7iMM7iMM7iMM7iMM7iMO20un///9gns7z+PuFtdqpbALuAAAACHRSTlMAYL//ACDP71kzCuAAAADmSURBVHgB7dYxTUZBFEThqwEUEBTAFNy8bLmggKAAFKDiSiCUlCj4cbDBFDV7/sdOSfGm/nLqiYgL/bmr3qM/abGXHvevK3T3GA9a7jku1+gmrtfoNmTsQP8e1dvvnUXpIJWD0kEqB6WDVA5KB6kclA7aHPRpoO20jxgiYoiIISKGiBjaRwwRMUTEEBFDRAh9FRBC7x9JhJBUQAhJSYSQVEAISUmkOSQV0ZhCUhK1OSQVkMYUkpKozSGJSGMKnUWNISINhogaQ0QaDBE1hoj0jRDQ/g4k79BY18g6WdZds45f7+sL+QOVKMyW3Co69gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2197.png
// module id = 1319
// module chunks = 0